import { Component, forwardRef, inject, Input } from '@angular/core';
import { AbstractFormControl } from '../abstract-form-control';
import { TagItemDto, TagService } from '@artemis-software/wr-api';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { asyncComputed } from '@/utils/signals/asyncComputed';
import { Tracked } from '@/utils/signals/tracked';

@Component({
  standalone: false,
  selector: 'wr-tag-select',
  templateUrl: './tag-select.component.html',
  styleUrls: ['./tag-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TagSelectComponent),
      multi: true,
    },
  ],
})
export class TagSelectComponent extends AbstractFormControl<TagItemDto[]> {
  tagService = inject(TagService);

  @Input()
  @Tracked()
  tenantId: string | undefined;

  readonly tags = asyncComputed(() => this.tagService.findAll({ tenantId: this.tenantId }));

  constructor() {
    super();
  }
}
